// Imported first by main.tsx. Zod 4 decides at schema creation whether it may JIT-compile object parsers, and
// finds out by calling `new Function("")` in a try/catch. Under the S5 CSP (no 'unsafe-eval') that throw is
// swallowed but still fires a `securitypolicyviolation`. Jitless skips the probe and uses the interpreted parser.
import { z } from "zod";

z.config({ jitless: true });
